// src/components/Legal/PrivacyEs.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyEs = () => {
  return (
    <div className="container py-4 legal-page">
      <h1>Política de Privacidad de Tzone</h1>
      <p><strong>Última actualización:</strong> {new Date().toLocaleDateString()}</p>

      <h2>1. Quiénes somos</h2>
      <p>
        Tzone es una plataforma para la planificación, seguimiento y análisis del
        entrenamiento deportivo, operada por <strong>TZONE Corp SpA</strong>,
        RUT <strong>77923319-7</strong>, con domicilio en Lo Barnechea,
        Santiago de Chile (en adelante, “<strong>Tzone</strong>”, “nosotros” o “la plataforma”).
      </p>
      <p>
        Si tienes dudas sobre esta política o sobre el tratamiento de tus datos personales,
        puedes escribirnos a: <a href="mailto:contacto@tzone.run">contacto@tzone.run</a>.
      </p>

      <h2>2. Ámbito de aplicación</h2>
      <p>
        Esta Política de Privacidad aplica al uso de la plataforma Tzone, el sitio web{' '}
        <strong>tzone.run</strong> y las aplicaciones asociadas, incluyendo integraciones con
        terceros como Garmin Connect u otros servicios de registro de actividad física.
      </p>

      <h2>3. Datos que tratamos</h2>
      <p>Dependiendo de cómo uses Tzone, podemos tratar las siguientes categorías de datos:</p>
      <ul>
        <li>
          <strong>Datos de cuenta:</strong> nombre, apellido, correo electrónico, país, idioma,
          tipo de usuario (atleta/entrenador) y credenciales de acceso cifradas.
        </li>
        <li>
          <strong>Datos de perfil deportivo:</strong> fecha de nacimiento, sexo, estatura, peso,
          umbrales fisiológicos, zonas de entrenamiento y otra información necesaria para
          personalizar el análisis.
        </li>
        <li>
          <strong>Datos de entrenamiento:</strong> sesiones planificadas y realizadas,
          métricas de esfuerzo (por ejemplo, duración, frecuencia cardíaca, potencia, ritmo,
          TSS, etc.), comentarios del atleta y del entrenador, y archivos técnicos como FIT,
          TCX u otros formatos similares.
        </li>
        <li>
          <strong>Datos procedentes de terceros:</strong> cuando conectas Tzone con servicios
          externos (por ejemplo, Garmin Connect), recibimos los datos que tú autorizas
          expresamente a compartir desde dichos servicios.
        </li>
        <li>
          <strong>Datos técnicos:</strong> identificadores de dispositivo, logs de seguridad,
          dirección IP aproximada, navegador y actividad básica de uso de la plataforma.
        </li>
      </ul>

      <h2>4. Finalidades del tratamiento</h2>
      <p>Utilizamos tus datos para:</p>
      <ul>
        <li>Crear y administrar tu cuenta de usuario en Tzone.</li>
        <li>
          Sincronizar, almacenar y mostrar tus datos de entrenamiento para que tú y, en su caso,
          tu entrenador puedan planificar, seguir y analizar el rendimiento deportivo.
        </li>
        <li>
          Calcular métricas derivadas (por ejemplo, cargas de entrenamiento, indicadores de
          fatiga y forma) basadas en tus datos de actividad.
        </li>
        <li>
          Enviar notificaciones relacionadas con tus entrenamientos, recordatorios o cambios de
          planificación, siempre que estén activadas en tu cuenta.
        </li>
        <li>
          Mantener la seguridad de la plataforma, prevenir usos indebidos y cumplir obligaciones
          legales o requerimientos de autoridades competentes.
        </li>
        <li>
          Mejorar el servicio y desarrollar nuevas funcionalidades, utilizando datos
          anonimizados o agregados cuando sea posible.
        </li>
      </ul>

      <h2>5. Bases legales</h2>
      <p>
        El tratamiento de tus datos se sustenta, según corresponda, en las siguientes bases
        legales:
      </p>
      <ul>
        <li>
          <strong>Ejecución de un contrato:</strong> cuando tratamos tus datos para prestarte el
          servicio de Tzone según los Términos y Condiciones aceptados.
        </li>
        <li>
          <strong>Consentimiento:</strong> cuando conectas servicios de terceros (por ejemplo,
          Garmin Connect) y autorizas expresamente el intercambio de datos.
        </li>
        <li>
          <strong>Interés legítimo:</strong> para mantener la seguridad de la plataforma, prevenir
          el fraude y mejorar la experiencia de usuario, siempre respetando tus derechos y
          libertades.
        </li>
        <li>
          <strong>Cumplimiento de obligaciones legales:</strong> cuando la normativa aplicable nos
          obliga a conservar o comunicar determinados datos.
        </li>
      </ul>

      <h2>6. Compartición de datos y destinatarios</h2>
      <p>
        Tzone no vende tus datos personales. Solo los compartimos con terceros en los siguientes casos:
      </p>
      <ul>
        <li>
          <strong>Proveedores tecnológicos:</strong> servicios de hosting, bases de datos,
          herramientas de correo electrónico y analítica que nos ayudan a operar la plataforma.
        </li>
        <li>
          <strong>Integraciones deportivas:</strong> servicios como Garmin Connect u otros,
          únicamente cuando tú activas la integración y bajo tu autorización expresa.
        </li>
        <li>
          <strong>Entrenadores y clubes:</strong> cuando tú aceptas vincular tu cuenta con un
          entrenador o club específico, este podrá ver la información necesaria para la
          planificación y el seguimiento de tu entrenamiento.
        </li>
        <li>
          <strong>Autoridades o terceros legitimados:</strong> cuando exista una obligación legal
          o una orden de autoridad competente.
        </li>
      </ul>

      <h2>7. Transferencias internacionales</h2>
      <p>
        Algunos de nuestros proveedores pueden estar ubicados fuera de Chile u operar desde
        múltiples jurisdicciones. En estos casos, exigimos que implementen garantías adecuadas
        de protección de datos (por ejemplo, cláusulas contractuales, estándares de seguridad
        reconocidos internacionalmente y pseudonimización o cifrado de la información).
      </p>

      <h2>8. Plazos de conservación</h2>
      <p>
        Conservamos tus datos mientras tu cuenta se mantenga activa y durante un plazo
        adicional razonable para atender posibles reclamaciones o exigencias legales. Puedes
        solicitar en cualquier momento la eliminación de tu cuenta; en ese caso, borraremos o
        anonimizaremos tus datos en la medida permitida por la normativa aplicable.
      </p>

      <h2>9. Tus derechos</h2>
      <p>
        De acuerdo con la legislación chilena aplicable y, en su caso, otras normas de
        protección de datos, puedes ejercer los siguientes derechos:
      </p>
      <ul>
        <li>Acceso a tus datos personales.</li>
        <li>Rectificación o actualización de datos inexactos o incompletos.</li>
        <li>Eliminación o bloqueo de datos cuando corresponda.</li>
        <li>Oposición o limitación al tratamiento en determinados casos.</li>
        <li>
          Portabilidad de los datos que nos hayas proporcionado, cuando esto sea técnicamente
          posible.
        </li>
      </ul>
      <p>
        Para ejercer estos derechos, escríbenos a{' '}
        <a href="mailto:contacto@tzone.run">contacto@tzone.run</a> indicando tu nombre completo,
        el derecho que deseas ejercer y la información necesaria para localizar tu cuenta.
      </p>

      <h2>10. Seguridad</h2>
      <p>
        Aplicamos medidas técnicas y organizativas razonables para proteger tus datos frente a
        accesos no autorizados, pérdida, destrucción o alteración. No obstante, ningún sistema
        es completamente infalible; por ello, también es importante que mantengas tus
        credenciales de acceso en lugar seguro y notifiques de inmediato cualquier uso no
        autorizado de tu cuenta.
      </p>

      <h2>11. Cambios en esta política</h2>
      <p>
        Podemos actualizar esta Política de Privacidad cuando sea necesario para reflejar
        cambios en la plataforma, en nuestros tratamientos de datos o en la normativa
        aplicable. Publicaremos siempre la versión vigente en <strong>tzone.run</strong> e
        indicaremos la fecha de la última actualización. En caso de cambios relevantes,
        podremos notificarlos por correo electrónico o dentro de la propia aplicación.
      </p>

      {/* 🔙 Botón para volver al Home */}
      <div className="mt-4">
        <Link to="/home" className="btn btn-outline-primary btn-sm">
          Volver al inicio
        </Link>
      </div>
    </div>
  );
};

export default PrivacyEs;
